import Vue from 'vue'
import store from '../store/store'
import i18n from '../i18n/i18n'
import { Notification } from 'element-ui'

let Admin = [
  'Create Project', 'Edit Project', 'Close Project',
  'Add Plan', 'Rename Plan', 'Delete Plan',
  'Add Task', 'Edit Task', 'Edit Tasks', 'Assign Task', 'Delete Task',
  'Edit Task Group', 'Create Task Group', 'Delete Task Group',
  'My Corp', 'Edit Member', 'Create Report', 'Upload', 'Edit Product'
]
let PM = [
  'Create Project', 'Edit Project', 'Close Project',
  'Add Plan', 'Rename Plan', 'Delete Plan',
  'Add Task', 'Edit Task', 'Edit Tasks', 'Assign Task', 'Delete Task',
  'Edit Task Group', 'Create Task Group', 'Delete Task Group',
  'Edit Member', 'Create Report', 'Upload', 'Edit Product'
]
let Superintendent = [
  'Edit Project', 'Add Plan',
  'Add Task', 'Edit Task', 'Edit Tasks', 'Assign Task', 'Delete Task',
  'Edit Task Group', 'Create Task Group', 'Delete Task Group',
  'Create Report', 'Upload', 'Edit Product'
]
let FieldRep = ['Create Report', 'Upload', 'Edit Product']
Vue.directive('has', (el, binding, vnode) => {
  let arr = []
  switch (store.state.userInfo.RoleType) {
    case 1:
      arr = Admin
      break
    case 2:
      arr = PM
      break
    case 3:
      arr = Superintendent
      break
    case 4:
      arr = FieldRep
      break
    default:
      arr = FieldRep
  }
  if (store.state.mockUserInfo && store.state.mockUserInfo.UserId > 0 && store.state.mockUserInfo.isViewer === true) {
    arr = []
  }
  if (arr.indexOf(binding.value) === -1) {
    el.style.display = 'none'
    el.remove()
  }
})
const baseURL = process.env.VUE_APP_BASEURL

const planURL = process.env.VUE_APP_PLANURL
let menu = [
  {
    id: 4,
    name: 'dashboard',
    title: i18n.t('static.Overview'),
    type: 'project',
    icon: 'overview'
  },
  {
    id: 5,
    name: 'diagrams',
    title: i18n.t('static.plan'),
    type: 'project',
    icon: 'plans'
  },
  {
    id: 6,
    name: 'tasks',
    title: i18n.t('static.Tasks'),
    type: 'project',
    icon: 'tasks'
  },
  {
    id: 7,
    name: 'groups',
    title: i18n.t('static.TaskGroups'),
    type: 'project',
    icon: 'task groups'
  },
  {
    id: 13,
    name: 'labors',
    title: i18n.t('static.Labor'),
    type: 'project',
    icon: 'labor'
  },
  {
    id: 8,
    name: 'reports-project',
    title: i18n.t('static.Reports'),
    type: 'project',
    icon: 'report'
  },
  {
    id: 14,
    name: 'analytics',
    title: i18n.t('static.Liveanalytics'),
    type: 'project',
    icon: 'analytics'
  },
  {
    id: 11,
    name: 'products',
    title: i18n.t('static.Products'),
    type: 'project',
    icon: 'products'
  },
  {
    id: 9,
    name: 'photos',
    title: i18n.t('static.Photos'),
    type: 'project',
    icon: 'photos'
  },
  {
    id: 10,
    name: 'documents',
    title: i18n.t('static.Documents'),
    type: 'project',
    icon: 'documents'
  },
  {
    id: 12,
    name: 'members',
    title: i18n.t('static.Members'),
    type: 'project',
    icon: 'members'
  },
  {
    id: 20,
    name: 'corp',
    title: i18n.t('static.MyCorp'),
    type: 'setting',
    icon: 'corp'
  },
  {
    id: 21,
    name: 'users',
    title: i18n.t('static.UserManagement'),
    type: 'setting',
    icon: 'members'
  },
  {
    id: 22,
    name: 'license',
    title: i18n.t('static.Subscription'),
    type: 'setting',
    icon: 'edit'
  },
  // {
  //   id: 28,
  //   index: '/setting/role',
  //   title: i18n.t('router.role'),
  //   type: 'setting',
  //   icon: 'default (2)'
  // },
  {
    id: 23,
    name: 'corporations',
    title: i18n.t('static.Corporations'),
    type: 'management',
    icon: 'corp'
  },
  {
    id: 24,
    name: 'allUsers',
    title: i18n.t('static.AllUsers'),
    type: 'management',
    icon: 'members'
  },
  // {
  //   id: 25,
  //   index: '/setting/laborItems',
  //   title: i18n.t('static.LaborItems'),
  //   type: 'setting',
  //   icon: 'labor'
  // },
  {
    id: 26,
    name: 'corpSetting',
    title: i18n.t('static.Settings'),
    type: 'setting',
    icon: 'setting'
  },
  {
    id: 27,
    name: 'sysSetting',
    title: i18n.t('static.SysSetting'),
    type: 'management',
    icon: 'setting'
  },
  {
    id: 28,
    name: 'notificationSetting',
    title: i18n.t('static.Notifications'),
    type: 'setting',
    icon: 'notifications'
  },
  {
    id: 29,
    name: 'checklistTemplates',
    title: i18n.t('static.ChecklistTemplates'),
    type: 'setting',
    icon: 'checklistTemplates'
  },
  {
    id: 30,
    name: 'taskTemplates',
    title: i18n.t('static.TaskTemplates'),
    type: 'setting',
    icon: 'tasks'
  },
  {
    id: 31,
    name: 'taskGroupTemplates',
    title: i18n.t('static.TaskGroupTemplates'),
    type: 'setting',
    icon: 'task groups'
  },
  {
    id: 32,
    name: 'tags',
    title: i18n.t('static.Tags'),
    type: 'setting',
    icon: 'tag'
  }
]
let reportType = [{
  name: 'MoistureReport',
  val: 0
},
{
  name: 'CompletionReport',
  val: 1
},
{
  name: 'IssueReport',
  val: 2
},
{
  name: 'TaskReport',
  val: 3
},
{
  name: 'GroupReport',
  val: 4
}
]
function toTimestamp (time) {
  let tPos = time.indexOf('T')
  let zPos = time.indexOf('Z')
  let yearMouthDay = time.substring(0, tPos)
  let hourMinSec = time.substring(tPos + 1, zPos)
  let newTime = yearMouthDay + ' ' + hourMinSec
  console.log(newTime)
  let timestamp = Date.parse(newTime)
  return timestamp
}
function LocalTime (time, showSecond = false) {
  if (!time) {
    return ''
  }
  let datetime = new Date(time)
  let year = datetime.getFullYear()
  let month = datetime.getMonth()
  let date = datetime.getDate()
  let hour = datetime.getHours()
  let minute = datetime.getMinutes()
  let second = datetime.getSeconds()
  let result =
    ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
    '/' +
    (date < 10 ? '0' + date : date) +
    '/' +
    year +
    ' ' +
    (hour < 10 ? '0' + hour : hour) +
    ':' +
    (minute < 10 ? '0' + minute : minute)
  if (showSecond) {
    result += ':' + ((second + 1) < 10 ? '0' + second : second)
  }
  return result
}

function StatusColorTask (time, done) {
  let color = 'Normal'
  if (done >= 100) {
    color = 'Complete'
  } else {
    if (time) {
      color = new Date().getTime() - (new Date(time).getTime() + 86399000) > 0 ? 'Danger' : 'Normal'
    }
  }
  return color
}

function StatusColorProduct (time, done) {
  let color = 'Normal_i'
  if (done >= 100) {
    color = 'Complete'
  } else {
    if (time) {
      color = new Date().getTime() - (new Date(time).getTime() + 86399000) > 0 ? 'Danger' : 'Normal_i'
    }
  }
  return color
}

function StatusColorMoisture (time, rh, maxRh, sleeveDropped) {
  let color = sleeveDropped === true ? 'Normal_i' : 'Normal_m'
  if (!time && !rh) {
    return color
  }
  if (rh) {
    if (rh <= maxRh) {
      color = 'Complete'
    } else if (rh > maxRh) {
      color = 'Danger'
    }
    return color
  }
  if (time) {
    color = new Date().getTime() - (new Date(time).getTime() + 86399000) > 0 ? 'Danger' : color
    return color
  }
}

function transform (num, unit) {
  let count = {}
  switch (unit) {
    case 0:
      count.num = 0
      count.text = 0
      break
    case 1: // cm
      count.num = num
      count.text = 'CM'
      break
    case 2: // m
      count.num = num / 1000
      count.text = 'M'
      break
    case 3: // ft
      count.num = num / 304.8
      count.text = 'LF'
      break
    case 4: // m^2
      count.num = num / 1000000
      count.text = 'M²'
      break
    case 5: // ft^2
      count.num = num / 304.8 / 304.8
      count.text = 'SF'
      break
    case 6: // sq yd
      count.num = num / 836127.36
      count.text = 'SY'
      break
    case 10: // ea
      count.num = num.toFixed(0)
      count.text = 'EA'
      break
    case 11:
      let Num = num * 0.039370
      count.length1 = Num | 0
      count.length2 = ((Num % 1) / 0.08333333).toFixed(2)
      break
  }
  if (count.num) {
    count.num = numberFormat(getFormatNumber(count.num, 2))
  }
  return count
}

function Address (obj) {
  for (let i in obj) {
    if (obj[i] && obj[i] !== '' && i !== 'ZipCode') {
      obj[i] = obj[i] + ', '
    } else if (!obj[i]) {
      obj[i] = ''
    }
  }
  let string = obj.Street + obj.City + obj.State + obj.Country + obj.ZipCode
  return string
}

function getFirstLastNameByFullName (name) {
  let result = {
    FirstName: '',
    LastName: ''
  }
  if (name && name.length > 0) {
    let index = name.indexOf(' ')
    if (index > 0) {
      result.FirstName = name.slice(0, index)
      result.LastName = name.slice(index + 1)
    } else {
      result.FirstName = name
      result.LastName = ''
    }
  }
  return result
}

function groupBy (array, f) {
  let groups = {}
  array.forEach(o => {
    let group = JSON.stringify(f(o))
    groups[group] = groups[group] || []
    groups[group].push(o)
  })
  return Object.keys(groups).map(function (group) {
    return groups[group]
  })
}

function getFormatNumber (num, decimal = 1) {
  let value = Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal) // 四舍五入
  value = Number(value).toFixed(decimal)
  return parseFloat(value)
}

function formatDuring (dateTime) {
  let timeSpanStr
  timeSpanStr = Math.round(dateTime / (1000 * 60 * 60))
  return timeSpanStr
}

function licenseText (obj) {
  if (obj.IsTrial) {
    let text = obj.LicenseQty + i18n.t('static.FreeLicenses') + (obj.LicenseQty - obj.ResidualLicenseQty) + i18n.t('static.assigned')
    return text
  } else {
    if (!obj.LicenseExpired) {
      if (!obj.InSubscription) {
        let diffDay = obj.DueDays
        if (isLicenseExpirationDayNeedRemind(diffDay)) {
          if (diffDay < 1) {
            diffDay = 1
          }
          let text = i18n.t('static.YourSubscriptionWillExpired', [obj.LicenseProductName, Math.ceil(diffDay)])
          return text
        }
      }
      let text = obj.LicenseQty + i18n.t('static.licensesPurchased') + (obj.LicenseQty - obj.ResidualLicenseQty) + i18n.t('static.assigned')
      return text
    } else {
      let text = i18n.t('static.YourSubscriptionIsExpired')
      return text
    }
  }
}

function isLicenseExpirationDayNeedRemind (diffDay) {
  return diffDay < 7
}

function getAssignment (item) {
  let arr = []
  if (item.length > 0) {
    item.forEach(ele => {
      if (ele.planRegions) {
        ele.planRegions.forEach(i => {
          for (let j in i) {
            if (j === 'areaAssignments' || j === 'countAssignments' || j === 'lineAssignments') {
              if (i[j].length > 0) {
                i[j].forEach(x => {
                  arr.push(x)
                })
              }
            }
          }
        })
      } else {
        for (let i in ele) {
          if (i === 'areaAssignments' || i === 'countAssignments' || i === 'lineAssignments') {
            arr.push(ele[i][0])
          }
        }
      }
    })
  } else if (item.length === undefined) {
    for (let i in item.planRegions[0]) {
      if (i === 'areaAssignments' || i === 'countAssignments' || i === 'lineAssignments') {
        item.planRegions[0][i].forEach(ele => {
          arr.push(ele)
        })
      }
    }
    if (item.elevations.length > 0) {

    }
  }
  return arr
}

function UTCTime (dateTime, isToday, onlyDate, end) {
  if (isToday === true) {
    let currentDate = new Date()
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0, 0)
  }
  if (onlyDate === true) {
    let date = new Date(dateTime)
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)
  }
  if (end === true) {
    let date = new Date(dateTime)
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 0)
  }
  let date = new Date(dateTime)
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
}
function formatBytes (a, b) {
  if (a === 0) return '0 Bytes'
  let c = 1024; let d = b || 2; let e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
}
function beforeTimeText (dateTime) {
  let start = new Date(dateTime)
  let end = new Date()
  let delta = Math.round((+new Date() - new Date(dateTime)) / 1000)
  let minute = 60
  let hour = minute * 60
  let day = hour * 24
  let week = day * 7
  let matchYears = Math.floor(DIFFTIME(start, end, 'y'))
  let matchMonths = Math.floor(DIFFTIME(start, end, 'M'))
  let beforeText = ''
  if (matchMonths > 0 && matchYears < 1) {
    if (matchMonths < 2) {
      beforeText = i18n.t('static.aMonthAgo')
    } else {
      beforeText = matchMonths + i18n.t('static.monthsAgo')
    }
  } else if (matchYears > 0) {
    if (matchYears < 2) {
      beforeText = i18n.t('static.aYearAgo')
    } else {
      beforeText = matchYears + i18n.t('static.yearsAgo')
    }
  } else if (delta < 30) {
    beforeText = i18n.t('static.justThen')
  } else if (delta < minute) {
    beforeText = delta + i18n.t('static.secondsAgo')
  } else if (delta < 2 * minute) {
    beforeText = i18n.t('static.aMinuteAgo')
  } else if (delta < hour) {
    beforeText = Math.floor(delta / minute) + i18n.t('static.minutesAgo')
  } else if (Math.floor(delta / hour) === 1) {
    beforeText = i18n.t('static.1hourAgo')
  } else if (delta < day) {
    beforeText = Math.floor(delta / hour) + i18n.t('static.hoursAgo')
  } else if (delta < day * 2) {
    beforeText = i18n.t('static.yesterday')
  } else if (delta < week) {
    beforeText = Math.floor(delta / day) + i18n.t('static.daysAgo')
  } else if (delta > week && delta < week * 2) {
    beforeText = i18n.t('static.aWeekAgo')
  } else if (delta > week * 2) {
    beforeText = Math.floor(delta / week) + i18n.t('static.weeksAgo')
  }
  return beforeText
}
// 计算两个日期时间相差的年数、月数、天数、小时数、分钟数、秒数
// DIFFTIME(开始时间, 结束时间, [单位]), 单位可以是 "y" 、"M"、"d"、"h"、"m"、"s"'
// console.log(DIFFTIME('2019-6-30 13:20:00', '2020-10-01 11:20:32', 's'))
export const DIFFTIME = function (startTime, endTime, unit) {
  // 判断当前月天数
  function getDays (mouth, year) {
    let days = 30
    if (mouth === 2) {
      days = year % 4 === 0 ? 29 : 28
    } else if (mouth === 1 || mouth === 3 || mouth === 5 || mouth === 7 || mouth === 8 || mouth === 10 || mouth === 12) {
      // 月份为:1,3,5,7,8,10,12 时,为大月.则天数为31;
      days = 31
    }
    return days
  }
  const start = new Date(startTime)
  const end = new Date(endTime)
  // 计算时间戳的差
  const diffValue = end - start
  // 获取年
  const startYear = start.getFullYear()
  const endYear = end.getFullYear()
  // 获取月
  const startMouth = start.getMonth() + 1
  const endMouth = end.getMonth() + 1
  // 获取日
  const startDay = start.getDate()
  const endDay = end.getDate()
  // 获取小时
  const startHours = start.getHours()
  const endHours = end.getHours()
  // 获取分
  const startMinutes = start.getMinutes()
  const endMinutes = end.getMinutes()
  // 获取秒
  const startSeconds = start.getSeconds()
  const endSeconds = end.getSeconds()
  if (unit === 'y' || unit === 'M') {
    // 相差年份月份
    const diffYear = endYear - startYear
    // 获取当前月天数
    const startDays = getDays(startMouth, startYear)
    const endDays = getDays(endMouth, endYear)
    const diffStartMouth = (startDays - (startDay + ((startHours * 60 + startMinutes + startSeconds / 60) / 60 / 24) - 1)) / startDays
    const diffEndMouth = (endDay + ((endHours * 60 + endMinutes + endSeconds / 60) / 60 / 24) - 1) / endDays
    const diffMouth = diffStartMouth + diffEndMouth + (12 - startMouth - 1) + endMouth + (diffYear - 1) * 12
    if (unit === 'y') {
      return Math.floor(diffMouth / 12 * 100) / 100
    } else {
      return diffMouth
    }
  } else if (unit === 'd') {
    const d = parseInt(diffValue / 1000 / 60 / 60 / 24)
    return d
  } else if (unit === 'h') {
    const h = parseInt(diffValue / 1000 / 60 / 60)
    return h
  } else if (unit === 'm') {
    const m = parseInt(diffValue / 1000 / 60)
    return m
  } else if (unit === 's') {
    const s = parseInt(diffValue / 1000)
    return s
  } else {
    console.log('Unit is error')
  }
}
function colorRGB2Hex (color) {
  let rgb = color.split(',')
  let r = parseInt(rgb[0].split('(')[1])
  let g = parseInt(rgb[1])
  let b = parseInt(rgb[2].split(')')[0])
  let hex = '#ff' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
  return hex
}
// unit转Color
function unit2RGBA (v) {
  let alpha = (v >> 24 & 0xff) / 255
  let red = v >> 16 & 0xff
  let green = v >> 8 & 0xff
  let blue = v & 0xff
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}
// color转uint
function rgba2uint (color) {
  let rgbaStrArr = color.match(/(\d(\.\d+)?)+/g) || []
  let r = parseInt(rgbaStrArr[0])
  let g = parseInt(rgbaStrArr[1])
  let b = parseInt(rgbaStrArr[2])
  let a = parseFloat(rgbaStrArr[3])
  let ai = Math.floor(a * 255)
  r = r & 0xff
  g = g & 0xff
  b = b & 0xff
  ai = ai & 0xff
  return (r << 24) + (g << 16) + (b << 8) + (ai)
}

function unique (arr) {
  if (!Array.isArray(arr)) {
    return
  }
  let res = [arr[0]]
  for (let i = 1; i < arr.length; i++) {
    let flag = true
    for (let j = 0; j < res.length; j++) {
      if (arr[i] === res[j]) {
        flag = false
        break
      }
    }
    if (flag) {
      res.push(arr[i])
    }
  }
  return res
}
function arrUnique (arr, type) {
  let newArr = []
  let tArr = []
  if (arr.length === 0) {
    return arr
  } else {
    if (type) {
      for (let i = 0; i < arr.length; i++) {
        if (!tArr[arr[i][type]]) {
          newArr.push(arr[i])
          tArr[arr[i][type]] = true
        }
      }
      return newArr
    } else {
      for (let i = 0; i < arr.length; i++) {
        if (!tArr[arr[i]]) {
          newArr.push(arr[i])
          tArr[arr[i]] = true
        }
      }
      return newArr
    }
  }
}
function getProductNum (string) {
  let num
  switch (string) {
    case 'None':
      num = 0
      break
    case 'Carpet':
      num = 1
      break
    case 'Vinyl':
      num = 2
      break
    case 'Wall Paper':
      num = 3
      break
    case 'Carpet Tile':
      num = 4
      break
    case 'Vinyl Tile':
      num = 5
      break
    case 'Tile':
      num = 8
      break
    case 'Laminate':
      num = 9
      break
    case 'Hardwood':
      num = 10
      break
    case 'Concrete':
      num = 11
      break
    case 'Paint':
      num = 12
      break
    case 'Grout':
      num = 13
      break
    case 'Surface':
      num = 14
      break
    case 'Underlayment':
      num = 15
      break
    case 'Transition':
      num = 16
      break
    case 'Bullnose':
      num = 17
      break
    case 'Trim':
      num = 18
      break
    case 'Wall Base':
      num = 19
      break
    case 'Linear':
      num = 22
      break
    case 'Count':
      num = 24
      break
    case 'Pattern':
      num = 26
      break
    case 'Adhesive':
      num = 31
      break
    case 'Labor':
      num = 32
      break
    case 'Freight':
      num = 33
  }
  return num
}
function getUnit (string) {
  let num
  switch (string) {
    case 'None':
      num = 0
      break
    case 'CM':
      num = 1
      break
    case 'M':
      num = 2
      break
    case 'LF':
      num = 3
      break
    case 'SM':
      num = 4
      break
    case 'M²':
      num = 4
      break
    case 'SF':
      num = 5
      break
    case 'SY':
      num = 6
      break
    case 'Liter':
      num = 7
      break
    case 'CubicMeter':
      num = 8
      break
    case 'USGal':
      num = 9
      break
    case 'EA':
      num = 10
  }
  return num
}
function getProductAssignType (type) {
  let num
  switch (type) {
    case 'None':
      num = 0
      break
    case 'Area':
      num = 1
      break
    case 'Linear':
      num = 2
      break
    case 'Count':
      num = 3
      break
  }
  return num
}

function getTotalTime (startTime, endTime) {
  var start = new Date(startTime)
  var end = new Date(endTime)
  var total = end - start
  var minute = Math.floor(total / 1000 / 60)
  var hour = Math.floor(total / 1000 / 60 / 60)
  minute = minute - hour * 60
  return hour + ' : ' + minute
}

function getTotalHrs (startTime, endTime) {
  var start = new Date(startTime)
  var end = new Date(endTime)
  var total = end - start
  var hour = total / 1000 / 60 / 60
  return parseFloat(hour).toFixed(2)
}

function formatDate (date, fmt = 'MM/dd/yyyy hh:mm') {
  if (!date) {
    return ''
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (('00' + str).substr(str.length)))
    }
  }
  return fmt
}

let measureUnitTypes = [{ Key: 1, Value: i18n.t('static.Metric') + '(11m, 12m²)' }, {
  Key: 2, Value: i18n.t('static.Imperial') + '(5\'6", 28SF)'
}]

let temperatureUnits = [{ Key: 0, Value: i18n.t('static.Celsius') + '(°C)' }, {
  Key: 1, Value: i18n.t('static.Fahrenheit') + '(°F)'
}]

function fahrenheitToCelsius (num) {
  return getFormatNumber((num - 32.0) / 1.8)
}

function celsiusToFahrenheit (num) {
  return getFormatNumber(num * 1.8 + 32.0)
}

function getFormatTemperature (num, unit) {
  if (unit === 0) {
    return fahrenheitToCelsius(num) + '°C'
  }
  return getFormatNumber(num) + '°F'
}

function getGlobalmeasureUnit (num, assign) {
  let type = store.state.measureUnitType
  if (type !== 1) {
    if (assign === 1) {
      let result = num / 304.8 / 304.8
      let unitObj = {
        text: 'SF',
        num: getFormatNumber(result)
      }
      return unitObj
    } else {
      let result = num / 304.8
      let unitObj = {
        text: 'LF',
        num: getFormatNumber(result)
      }
      return unitObj
    }
  } else {
    if (assign === 1) {
      let result = num / 1000
      let unitObj = {
        text: 'M',
        num: getFormatNumber(result)
      }
      return unitObj
    } else {
      let result = num / 1000000
      let unitObj = {
        text: 'M²',
        num: getFormatNumber(result)
      }
      return unitObj
    }
  }
}
function handleTaskList (list) {
  list.forEach(ele => {
    ele.CompletionRate = Math.round(ele.CompletionRate * Math.pow(10, 1)) / Math.pow(10, 1)
    switch (ele.TaskType) {
      case 0:
        ele.icon = 'task_0'
        ele.point = 'task'
        break
      case 1:
        ele.icon = 'special_0'
        ele.point = 'product'
        break
      case 2:
        ele.icon = 'moisture_0'
        ele.point = 'moisture'
        break
      case 4:
        ele.icon = 'special_0'
        ele.point = 'product'
        break
    }
    if (ele.EndDate) {
      ele.EndDate = LocalTime(ele.EndDate)
    }
    if (ele.TaskType === 0) {
      ele.color = StatusColorTask(ele.EndDate, ele.CompletionRate)
    }
    if (ele.TaskType === 1 || ele.TaskType === 4) {
      ele.color = StatusColorProduct(ele.EndDate, ele.CompletionRate)
    }
    if (ele.TaskType === 2 && ele.LastRHReading) {
      ele.Concrete = getFormatNumber(ele.LastRHReading.ConcreteRH)
      ele.color = StatusColorMoisture(ele.EndDate, ele.LastRHReading.ConcreteRH, ele.MaxRh, ele.SleeveDropped)
    } else if (ele.TaskType === 2 && !ele.LastRHReading) {
      ele.color = StatusColorMoisture(ele.EndDate, null, ele.MaxRh, ele.SleeveDropped)
    }
  })
  return list
}
function handleProduct (product, taskShapes) {
  return new Promise((resolve, reject) => {
    let result = {}
    let WallBaseLinear = [16, 18, 19, 17, 22]
    let isWallBase = WallBaseLinear.indexOf(product.ProductType) !== -1
    if (product.AssignType === 1 && !isWallBase) {
      let total = 0
      for (let i of taskShapes) {
        total += i.ShapeArea
      }
      result.NetArea = total
      result.TotalQty = product.TotalQty
      result.Unit = transformUnit(product.TotalQty, product.Unit, product.ProductType).text
      result.transformTotal = transformUnit(product.TotalQty, product.Unit, product.ProductType).num
      result.transformNetArea = transformUnit(total, product.Unit, product.ProductType).num
    } else if (product.AssignType !== 1) {
      result.TotalQty = product.TotalQty
      result.Unit = transformUnit(product.TotalQty, product.Unit).text
      result.transformTotal = transformUnit(product.TotalQty, product.Unit).num
    }
    resolve(result)
  })
}

function transformUnit (num, unit, type = 0) {
  let count = {}
  // 这里要判断 可能出现Lf的面积型的type 然后将M或LF 转成 M2或SF
  var areaProductTypes = [1, 2, 3]
  if (areaProductTypes.indexOf(type) > -1) {
    if (unit === 2) {
      unit = 4
    }
    if (unit === 3) {
      unit = 5
    }
  }
  switch (unit) {
    case 0:
      count.num = 0
      count.text = 0
      break
    case 1: // cm
      count.num = num / 10
      count.text = 'CM'
      break
    case 2: // m
      count.num = num / 1000
      count.text = 'M'
      break
    case 3: // ft
      count.num = num / 304.8
      count.text = 'LF'
      break
    case 4: // m^2
      count.num = num / 1000000
      count.text = 'M²'
      break
    case 5: // ft^2
      count.num = num / 304.8 / 304.8
      count.text = 'SF'
      break
    case 6: // sq yd
      count.num = num / 836127.36
      count.text = 'SY'
      break
    case 10: // ea
      count.num = num.toFixed(0)
      count.text = 'EA'
      break
    case 11:
      let Num = num * 0.039370
      count.length1 = Num | 0
      count.length2 = ((Num % 1) / 0.08333333).toFixed(2)
      break
  }
  if (count.num) {
    count.num = numberFormat(getFormatNumber(count.num, 2))
  }
  return count
}

function getFileType (fileName) {
  let suffix = ''
  let result = ''
  try {
    let flieArr = fileName.toLowerCase().split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  let imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  result = imglist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 1
  }
  let videolist = ['mp4', 'm2v', 'mkv', 'mov', 'mp4', 'flv', 'mkv', 'wmv', 'avi', 'rmvb', 'vob']
  result = videolist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 2
  }
  let pdflist = ['pdf']
  result = pdflist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 3
  }
  return 0
}

function getIconForFileType (fileName, isFolder) {
  if (isFolder) {
    return 'folder.png'
  }
  let suffix = ''
  let result = ''
  try {
    let flieArr = fileName.toLowerCase().split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }

  if (!suffix) {
    return 'other@2x.png'
  }

  let imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  result = imglist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'image_default@2x.png'
  };

  let excelist = ['xls', 'xlsx']
  result = excelist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'excel@2x.png'
  };

  let wordlist = ['doc', 'docx']
  result = wordlist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'word@2x.png'
  };

  let pdflist = ['pdf']
  result = pdflist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'pdf@2x.png'
  };

  let pptList = ['ppt', 'pptx']
  result = pptList.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'ppt@2x.png'
  };

  let videolist = ['mp4', 'm2v', 'mkv', 'mov', 'mp4', 'flv', 'mkv', 'wmv', 'avi', 'rmvb', 'vob']
  result = videolist.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'video@2x.png'
  };

  let m2list = ['fez']
  result = m2list.some(function (item) {
    return item === suffix
  })
  if (result) {
    return 'M2__@2x.png'
  };
  return 'other@2x.png'
}
function sortArray (data, key, order) {
  if (order === 'asc') {
    data.sort((a, b) => a[key] - b[key])
  } else if (order === 'desc') {
    data.sort((a, b) => b[key] - a[key])
  }
  return data
}
function add (num1, num2) {
  let r1, r2, m
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (num1 * m + num2 * m) / m
}
function sub (num1, num2) {
  let r1, r2, m, n
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  n = Math.max(r1, r2)
  m = Math.pow(10, n)
  return Number(((num1 * m - num2 * m) / m).toFixed(n))
}
function multiply (num1, num2) {
  let m = 0
  let s1 = num1.toString()
  let s2 = num2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) { }
  try {
    m += s2.split('.')[1].length
  } catch (e) { }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}
function divide (num1, num2) {
  let t1, t2, r1, r2
  try {
    t1 = num1.toString().split('.')[1].length
  } catch (e) {
    t1 = 0
  }
  try {
    t2 = num2.toString().split('.')[1].length
  } catch (e) {
    t2 = 0
  }
  r1 = Number(num1.toString().replace('.', ''))
  r2 = Number(num2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}
function numberFormat (number, digNum) {
  digNum = digNum || 2
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+digNum) ? 0 : Math.abs(digNum)
  var s = n.toString().split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1,$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  } else {
    s[1] = s[1].substring(0, prec)
  }
  return s.join('.')
}

function StringFormat () {
  if (arguments.length === 0) { return null }

  var str = arguments[0]
  for (var i = 1; i < arguments.length; i++) {
    var re = new RegExp('\\{' + (i - 1) + '\\}', 'gm')
    str = str.replace(re, arguments[i])
  }
  return str
}
function validEmail (obj) {
  return /^[A-Za-z0-9]+(?:[._-]*[A-Za-z0-9]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/i.test(obj)
}
function validEmails (emails, msg) {
  var strEmail = []
  for (var i = 0; i < emails.length; i++) {
    var emailval = emails[i].trim()
    if (emailval !== '' && !validEmail(emailval)) { strEmail.push(emailval) }
  }
  if (strEmail.length !== 0) {
    msg = StringFormat(msg, "'" + strEmail.join(',') + "'")
    Notification.closeAll()
    Notification({
      title: i18n.t('api.WARNING'),
      message: msg,
      duration: 3000,
      showClose: false
    })
    return false
  }
  return true
}

function transformUnitToMM (num, unit) {
  let count = {}
  switch (unit) {
    case 0:
      count.num = 0
      break
    case 1: // CM
      count.num = num / 10
      break
    case 2: // M
      count.num = num * 1000
      break
    case 3: // LF
      count.num = num * 304.8
      break
    case 4: // M²
      count.num = num * 1000000
      break
    case 5: // SF
      count.num = num * 92903.04
      break
    case 6: // SY
      count.num = num * 836127.36
      break
    case 10: // EA
      count.num = num.toFixed(0)
      break
  }
  if (count.num) {
    count.num = numberFormat(getFormatNumber(count.num, 2))
  }
  return count
}

function transformMMToM2Unit (num, unit) {
  let count = {}
  switch (unit) {
    case 0:
      count.num = 0
      count.text = ''
      break
    case 1: // CM
      count.num = num * 10
      count.text = 'CM'
      break
    case 2: // M
      count.num = num / 1000
      count.text = 'M'
      break
    case 3: // LF
      count.num = num / 304.8
      count.text = 'LF'
      break
    case 4: // M²
      count.num = num / 1000000
      count.text = 'M²'
      break
    case 5: // SF
      count.num = num / 92903.04
      count.text = 'SF'
      break
    case 6: // SY
      count.num = num / 836127.36
      count.text = 'SY'
      break
    case 10: // EA
      count.num = Math.ceil(num)
      count.text = 'EA'
      break
  }
  if (count.num) {
    count.num = numberFormat(getFormatNumber(count.num, 2))
  }
  return count
}

function IsTrackableProduct (assign) {
  let prod = assign.prod
  let able = (!prod.isAddon || prod.type === 'Wall Base') && prod.type !== 'Pattern'
  if (able) {
    if (assign.netArea === 0 && assign.usage === 0) {
      able = false
    }
  }
  return able
}

function getNonM2ProductUnit (unit) {
  let unitStr = ''
  switch (unit) {
    case 0:
      unitStr = ''
      break
    case 1: // CM
      unitStr = 'CM'
      break
    case 2: // M
      unitStr = 'M'
      break
    case 3: // LF
      unitStr = 'LF'
      break
    case 4: // M²
      unitStr = 'M²'
      break
    case 5: // SF
      unitStr = 'SF'
      break
    case 6: // SY
      unitStr = 'SY'
      break
    case 7: // Liter
      unitStr = 'Liter'
      break
    case 8: // M³
      unitStr = 'M³'
      break
    case 9: // Gal
      unitStr = 'Gal'
      break
    case 10: // EA
      unitStr = 'EA'
      break
  }
  return unitStr
}

function getNonM2ProductUnitType (string) {
  let unit = 0
  switch (string) {
    case 'CM': // CM
      unit = 1
      break
    case 'M': // M
      unit = 2
      break
    case 'LF': // LF
      unit = 3
      break
    case 'M²': // M²
      unit = 4
      break
    case 'SF': // SF
      unit = 5
      break
    case 'SY': // SY
      unit = 6
      break
    case 'Liter': // Liter
      unit = 7
      break
    case 'M³': // M³
      unit = 8
      break
    case 'Gal': // Gal
      unit = 9
      break
    case 'EA': // EA
      unit = 10
      break
  }
  return unit
}
function getNonM2ProductType (type) {
  let typeStr = ''
  switch (type) {
    case 0:
      typeStr = ''
      break
    case 1:
      typeStr = 'Carpet'
      break
    case 2:
      typeStr = 'Vinyl'
      break
    case 3:
      typeStr = 'Wall Paper'
      break
    case 4:
      typeStr = 'Carpet Tile'
      break
    case 5:
      typeStr = 'Vinyl Tile'
      break
    case 8:
      typeStr = 'Tile'
      break
    case 9:
      typeStr = 'Laminate'
      break
    case 10:
      typeStr = 'Hardwood'
      break
    case 11:
      typeStr = 'Concrete'
      break
    case 12:
      typeStr = 'Paint'
      break
    case 13:
      typeStr = 'Grout'
      break
    case 14:
      typeStr = 'Surface'
      break
    case 15:
      typeStr = 'Underlayment'
      break
    case 16:
      typeStr = 'Transition'
      break
    case 17:
      typeStr = 'Bullnose'
      break
    case 18:
      typeStr = 'Trim'
      break
    case 19:
      typeStr = 'Wall Base'
      break
    case 22:
      typeStr = 'Linear'
      break
    case 24:
      typeStr = 'Count'
      break
    case 26:
      typeStr = 'Pattern'
      break
    case 31:
      typeStr = 'Adhesive'
      break
    case 32:
      typeStr = 'Labor'
      break
    case 33:
      typeStr = 'Freight'
      break
  }
  return typeStr
}
function matchContentType (fileName) {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var contentType = ''
  try {
    var flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  switch (suffix) {
    case 'svg':
      contentType = 'image/svg+xml'
      break
    case 'png':
      contentType = 'image/png'
      break
    case 'jpg':
      contentType = 'image/jpeg'
      break
    default:
      contentType = 'application/octet-stream'
      break
  }
  return contentType
}

function labelActivity (ele, userName) {
  let operateStr = i18n.t('home.createdaTask', [ele.TaskName])
  switch (ele.ActivityType) {
    case 1:
      operateStr = i18n.t('home.assignTheTask', [ele.TaskName, ele.AssignUserName])
      break
    case 2:
    case 4:
      operateStr = i18n.t('home.setTheProgress', [ele.TaskName, getFormatNumber(ele.Progress)])
      break
    case 3:
      operateStr = i18n.t('home.deletedaTask', [ele.TaskName])
      break
    case 5:
      operateStr = i18n.t('home.addRHReadingToTask', [ele.TaskName])
      break
    case 6:
      operateStr = i18n.t('home.addCaClReadingToTask', [ele.TaskName])
      break
    case 7:
      operateStr = i18n.t('home.removeaRH', [ele.TaskName])
      break
    case 8:
      operateStr = i18n.t('home.removeaCaCl', [ele.TaskName])
      break
    case 9:
      operateStr = i18n.t('home.createdaPlan', [ele.PlanName])
      break
    case 10:
      operateStr = i18n.t('home.deletedaPlan', [ele.PlanName])
      break
    case 11:
      operateStr = i18n.t('home.loggedInSystem')
      break
    case 12:
      operateStr = i18n.t('home.BatchCreateTask')
      break
    case 13:
      operateStr = i18n.t('home.BatchChangeTask')
      break
    case 14:
      operateStr = i18n.t('home.BatchDeleteTask')
      break
    case 15:
      operateStr = i18n.t('home.BatchCreatePlan')
      break
    case 16:
      operateStr = i18n.t('home.BatchDeletePlan')
      break
    case 17:
      operateStr = i18n.t('home.CreatedProject', [ele.JobsiteName])
      break
    case 18:
      operateStr = i18n.t('home.UpdatedProject', [ele.JobsiteName])
      break
    case 19:
      operateStr = i18n.t('home.ClosedProject', [ele.JobsiteName])
      break
    case 20:
      operateStr = i18n.t('home.RenamePlan', [ele.OldName, ele.PlanName])
      break
    case 21:
      operateStr = i18n.t('home.BatchUpdatedPlan')
      break
    case 22:
      operateStr = i18n.t('home.AddProjectMember', [ele.AssignUserName, ele.JobsiteName])
      break
    case 23:
      operateStr = i18n.t('home.DeletedProjectMember', [ele.AssignUserName, ele.JobsiteName])
      break
    case 24:
      operateStr = i18n.t('home.BatchAddProjectMember', [ele.JobsiteName])
      break
    case 25:
      operateStr = i18n.t('home.CreatedReport', [ele.ReportName])
      break
    case 26:
      operateStr = i18n.t('home.CompletedTask', [ele.TaskName])
      break
    case 27:
      operateStr = i18n.t('home.UpdatedTask', [ele.TaskName])
      break
    case 28:
      operateStr = i18n.t('home.AddTaskChecklist', [ele.ChecklistName, ele.TaskName])
      break
    case 29:
      operateStr = i18n.t('home.AddTaskChecklistItem', [ele.TaskChecklistItemName, ele.TaskName])
      break
    case 30:
      operateStr = i18n.t('home.DeleteTaskChecklistItem', [ele.TaskChecklistItemName, ele.TaskName])
      break
    case 31:
      operateStr = i18n.t('home.RenameTaskChecklistItem', [ele.OldName, ele.TaskChecklistItemName, ele.TaskName])
      break
    case 32:
      operateStr = i18n.t('home.CheckedTaskChecklistItem', [ele.TaskChecklistItemName, ele.TaskName])
      break
    case 33:
      operateStr = i18n.t('home.CrossTaskChecklistItem', [ele.TaskChecklistItemName, ele.TaskName])
      break
    case 34:
      operateStr = i18n.t('home.AddTaskPhoto', [ele.TaskName])
      break
    case 35:
      operateStr = i18n.t('home.DeleteTaskPhoto', [ele.TaskName])
      break
    case 36:
      operateStr = i18n.t('home.AddTaskVideo', [ele.TaskName])
      break
    case 37:
      operateStr = i18n.t('home.DeleteTaskVideo', [ele.TaskName])
      break
    case 38:
      operateStr = i18n.t('home.AddProjectDocument', [ele.FileName, ele.JobsiteName])
      break
    case 39:
      operateStr = i18n.t('home.DeleteProjectDocument', [ele.FileName, ele.JobsiteName])
      break
    case 40:
      operateStr = i18n.t('home.AddTaskDocument', [ele.FileName, ele.TaskName])
      break
    case 41:
      operateStr = i18n.t('home.DeleteTaskDocument', [ele.FileName, ele.TaskName])
      break
    case 42:
      operateStr = i18n.t('home.AnnotateTaskPhoto', [ele.TaskName])
      break
    case 43:
      operateStr = i18n.t('home.BatchAddTaskPhoto', [ele.TaskName])
      break
    case 44:
      operateStr = i18n.t('home.BatchAddTaskVideo', [ele.TaskName])
      break
    case 45:
      operateStr = i18n.t('home.CreateTaskGroup', [ele.TaskPhaseName])
      break
    case 46:
      operateStr = i18n.t('home.UpdateTaskGroup', [ele.TaskPhaseName])
      break
    case 47:
      operateStr = i18n.t('home.DeleteTaskGroup', [ele.TaskPhaseName])
      break
    case 48:
      operateStr = i18n.t('home.DeleteTaskChecklist', [ele.ChecklistName, ele.TaskName])
      break
    case 49:
      operateStr = i18n.t('home.UncheckedTaskChecklistItem', [ele.TaskChecklistItemName, ele.TaskName])
      break
    case 50:
      operateStr = i18n.t('home.CheckedTaskChecklist', [ele.ChecklistName, ele.TaskName])
      break
    case 51:
      operateStr = i18n.t('home.UncheckedTaskChecklist', [ele.ChecklistName, ele.TaskName])
      break
    case 55:
      operateStr = i18n.t('home.ReopenedProject')
      break
    case 56:
      operateStr = i18n.t('home.DeletePlanTag', [ele.TagName, ele.PlanName])
      break
    case 57:
      operateStr = i18n.t('home.AddPlanTag', [ele.TagName, ele.PlanName])
      break
    case 60:
      operateStr = i18n.t('home.RenameProjectDocument', [ele.OldName, ele.FileName])
      break
    case 61:
      operateStr = i18n.t('home.MoveProjectDocument', [ele.FileName, ele.OldName])
      break
    case 62:
      operateStr = i18n.t('home.AddFolder', [ele.FolderName])
      break
    case 63:
      operateStr = i18n.t('home.RenameFolder', [ele.OldName, ele.FolderName])
      break
    case 64:
      operateStr = i18n.t('home.DeleteFolder', [ele.FolderName])
      break
  }
  ele.Title = userName + ' ' + operateStr
  ele.BeforeText = beforeTimeText(ele.CreatedOn)
}

function taskImg (diag, task, urlList, imgObj) {
  let marker = null
  return new Promise((resolve, reject) => {
    diag.state.onDraw = (context) => {
      if (!task.imgURL) {
        let url = context.canvas.toDataURL('image/png', 1)
        urlList.push({
          id: task.TaskId, url: url
        })
        if (marker) {
          diag.removeMarker(marker.id)
        }
        diag.setLayer(diag.layers[0].id)
        resolve()
      }
    }
    diag.partialShow(task.RoomShapeIdList)
    let point = {
      x: task.LocationX,
      y: task.LocationY
    }
    let img
    if (task.LocationType === 2) {
      img = imgObj[task.point + task.color + 'Wall']
    } else {
      img = imgObj[task.point + task.color]
    }
    let pinWidth = 50
    marker = diag.addMarker(point, img, pinWidth, pinWidth, true)
    diag.resetView()
  })
}
async function diagLoadCompleted (obj, layerList, layerTaskList, option, imgObj) {
  let layer = layerList.find(q => q.PlanId === obj.planId)
  layer.diag = obj.diag
  let taskList = layerTaskList.filter(q => q.PlanId === obj.planId)
  if (option.ShowTaskList) {
    let urlList = []
    for (let task of taskList) {
      await taskImg(obj.diag, task, urlList, imgObj)
    }
    for (let item of urlList) {
      let task = taskList.find(q => q.TaskId === item.id)
      task.imgURL = item.url
    }
    urlList = null
  }
  let ele = document.querySelector('#diag_' + obj.planId)
  if (option.ShowFloorPlan) {
    if (ele) {
      ele.style.width = '100%'
      ele.style.height = '750px'
    }
    obj.diag.refresh()
  } else {
    if (ele) {
      ele.remove()
    }
    obj.diag = null
  }
  setTimeout(function () {
    layer.taskList = taskList
  }, 100)
}
function planImgLoadCompleted (obj, layerList) {
  if (layerList) {
    let layer = layerList.find(q => q.PlanId === obj.planId)
    layer.loadCompleted = true
    if (!layerList.find(q => q.loadCompleted === false)) {
      return true
    }
    return false
  }
  return true
}
async function pdftronLoadCompleted (planId, layerList, option, reportComponent, imgObj, loadCompleted) {
  let taskList = layerList.filter(q => q.PlanId === planId)
  if (option.ShowTaskList) {
    pdftronShowTaskList(imgObj, reportComponent, taskList)
  } else {
    await pdftronShowFloorPlan(reportComponent, planId, option, layerList, taskList, imgObj, loadCompleted)
  }
}
async function TaskAnotCreated (task, pdfCreatedTaskAnot, layerTaskList, planId, reportComponent, option, layerList, imgObj, loadCompleted) {
  pdfCreatedTaskAnot.push(task)
  const taskList = layerTaskList.filter(q => q.PlanId === planId)
  const tasks = pdfCreatedTaskAnot.filter(q => q.PlanId === planId)
  if (tasks && tasks.length === taskList.length) {
    await pdftronShowFloorPlan(reportComponent, planId, option, layerList, taskList, imgObj, loadCompleted)
  }
}
function pdftronShowTaskList (imgObj, reportComponent, taskList) {
  for (let task of taskList) {
    pdftronTaskImg(imgObj, reportComponent, task)
  }
}
function pdftronTaskImg (imgObj, reportComponent, task) {
  let img = imgObj[task.point + task.color]
  reportComponent.setTaskImg(img, task)
}
async function pdftronShowFloorPlan (reportComponent, planId, option, layerList, taskList, imgObj, loadCompleted) {
  let ele = document.querySelector('#diag_' + planId)
  if (option.ShowFloorPlan) {
    await reportComponent.loadXfdfStrings()
    let layer = layerList.find(q => q.PlanId === planId)
    for (let task of taskList) {
      let img = imgObj[task.point + task.color]
      reportComponent.createTaskImgAnnotation(img, task.LocationX, task.LocationY)
    }
    layer.taskList = taskList
  } else {
    // ele.style.cssText = 'width: 0; height: 0;'
    ele.remove()
  }
  loadCompleted({ planId: planId })
}
function splitGroupArray (array = [], subGroupLength = 0) {
  let index = 0
  const newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength))
  }
  return newArray
}
// 得到一个两数之间的随机整数，不含最大值，含最小值
function getRandomInt (min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}
export default {
  baseURL,
  planURL,
  LocalTime,
  transform,
  reportType,
  StatusColorTask,
  StatusColorProduct,
  StatusColorMoisture,
  Address,
  groupBy,
  getFormatNumber,
  menu,
  formatDuring,
  licenseText,
  isLicenseExpirationDayNeedRemind,
  getAssignment,
  UTCTime,
  beforeTimeText,
  formatBytes,
  colorRGB2Hex,
  unit2RGBA,
  rgba2uint,
  unique,
  getProductNum,
  getUnit,
  arrUnique,
  getTotalTime,
  getTotalHrs,
  formatDate,
  measureUnitTypes,
  temperatureUnits,
  fahrenheitToCelsius,
  celsiusToFahrenheit,
  getFormatTemperature,
  getGlobalmeasureUnit,
  handleTaskList,
  getProductAssignType,
  handleProduct,
  getIconForFileType,
  getFileType,
  Admin,
  PM,
  Superintendent,
  FieldRep,
  sortArray,
  add, // 加法精度计算
  sub, // 减法精度计算
  multiply, // 成法精度计算
  divide, // 除法精度计算
  numberFormat, // 格式化千位符
  validEmail,
  validEmails,
  transformUnit,
  transformUnitToMM,
  transformMMToM2Unit,
  getNonM2ProductUnit,
  getNonM2ProductUnitType,
  IsTrackableProduct,
  getNonM2ProductType,
  StringFormat,
  matchContentType,
  labelActivity,
  taskImg,
  diagLoadCompleted,
  pdftronLoadCompleted,
  TaskAnotCreated,
  planImgLoadCompleted,
  splitGroupArray,
  toTimestamp,
  getFirstLastNameByFullName,
  getRandomInt
}
